import React, { useEffect, useState } from "react";
import WeekScheduleTypeGrouping from "./WeekScheduleTypeGrouping";
import StoreName from "./StoreName";
import Account from "./Account";
import TabsThree from "../../requests/shared/helpers/TabsThree";
import ScheduleTypeFilter from "./ScheduleTypeFilter";
import Notifications from "./Notifications";


function TopBarDisplay(props) {

  const [activeTab, setActiveTab] = React.useState('Week')

  function handleTabButtonPress(target) {
    setActiveTab(target)

    // When switching to Day view, default to today if it's within the current week
    let dayIndex = 0;
    if (target === 'Day') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const weekStart = new Date(props.start_date);
      weekStart.setHours(0, 0, 0, 0);
      const diffTime = today - weekStart;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      // If today is within the current week (0-6 days from start), use that day
      if (diffDays >= 0 && diffDays <= 6) {
        dayIndex = diffDays;
      }
    }

    props.setView(target, dayIndex)
  }

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <div className="flex items-center flex-shrink-0">
          <div className={`${props.windowWidth > 1100 ? "w-80" : "w-72"}`}>
            <WeekScheduleTypeGrouping
              start_date={props.start_date}
              end_date={props.end_date}
              increment_week={props.increment_week}
              roleType={props.roleType}
              setRoleType={props.setRoleType}
              roleTypeOptions={props.roleTypeOptions}
              set_week_start_date={props.set_week_start_date}
              businessWeekStartDayIndex={props.businessWeekStartDayIndex}
            />
          </div>
          {props.windowWidth > 1300 &&
            <div className="w-52" data-help-id="schedule-view-tabs">
              <TabsThree
                activeTab={activeTab}
                handleTabButtonPress={handleTabButtonPress}
                tab1="Week"
                tab2="Day"
                tab3="Month"
                type="TopBar"
              />
            </div>
          }
        </div>
        <div className="flex items-center flex-shrink-0">
          <div className="mr-4">
            <ScheduleTypeFilter
              roleType={props.roleType}
              setRoleType={props.setRoleType}
              roleTypeOptions={props.roleTypeOptions}
            />
          </div>
          <div className="mr-6">
            <StoreName
              storeOptions={props.storeOptions}
              homeStore={props.homeStore}
              storeNames={props.storeNames}
              change_home_store={props.change_home_store}
            />
          </div>
          <div className="mr-8">
            <Notifications
              homeStore={props.homeStore}
            />
          </div>
          <div className="h-10 flex items-center justify-center cursor-pointer">
            <Account />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBarDisplay;
